import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=72e6f5fc"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e6f5fc')) {
      api.createRecord('72e6f5fc', component.options)
    } else {
      api.reload('72e6f5fc', component.options)
    }
    module.hot.accept("./ProductInfo.vue?vue&type=template&id=72e6f5fc", function () {
      api.rerender('72e6f5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfo.vue"
export default component.exports